import UserBadgeList from "./BadgeList";
import UserBadgeShow from "./BadgeShow";
export default {
  list: UserBadgeList,
  show: UserBadgeShow,
};
